// LA TIENDA (/administracion/tienda y /administracion/tienda/<aparato>)   (t217, 14-oct-2026, B-1642)
//
// El dueño: «Lo del enlace del escáner lo pondría en una especie de "Tienda" en panel admin... así si el día de mañana lo
// vendemos nosotros pues es más fácil». Una entrada del panel de administración con una tarjeta por aparato (la tablet del
// quiosco, la de firmar, el lector de códigos, el escáner y lo que Biango añada): para qué sirve en Biango, qué tiene que
// tener y «Comprar», que lleva a su enlace de afiliado o, si lo vende Biango, a su tienda (utils/tienda · comprasDe).
// La ficha de un aparato es /administracion/tienda/<aparato>: ahí llevan los «Ver en la Tienda» de las pantallas que lo
// piden. Los datos son de Biango (GET /api/enlaces-compra/tienda, services/enlacesCompra); los ve cualquiera con sesión.
// /donde-comprar/<aparato> (el enlace del 13-oct) lleva a su ficha: RedirDondeComprar.
import { useParams, Link, Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import api from '../services/api'
import { TarjetaProducto, PieTienda, productosQueSirven, RUTA_TIENDA, rutaProducto } from '../utils/tienda'
import { t } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export default function Tienda() {
  const { producto } = useParams()
  const q = useQuery({
    queryKey: ['tienda'],
    queryFn: () => api.get('/enlaces-compra/tienda').then((r) => r.data),
    staleTime: 30 * 60 * 1000,
  })
  const productos = productosQueSirven(q.data)
  const frases = (q.data && Array.isArray(q.data.frases)) ? q.data.frases : []
  const uno = producto ? productos.find((p) => p.clave === producto) : null
  const verFicha = (clave) => (
    <Link to={rutaProducto(clave)} data-ver-ficha={clave} style={{ fontSize: '12.5px', fontWeight: 700, color: 'var(--primary)' }}>{t('pages.Tienda.ver_ficha', 'Ver ficha')}</Link>
  )
  return (
    <div data-pagina-tienda={producto || ''} style={{ width: '100%', maxWidth: '1100px', minWidth: 0, color: 'var(--text-primary)' }}>
      <h1 style={{ fontSize: '23px', fontWeight: 800, margin: '0 0 6px', lineHeight: 1.2 }}>{t('pages.Tienda.tienda', 'Tienda')}</h1>
      <p style={{ fontSize: '13px', color: 'var(--text-secondary)', lineHeight: 1.55, margin: '0 0 14px', maxWidth: '900px' }}>
        {t('pages.Tienda.los_aparatos_que_sirven_para', 'Los aparatos que sirven para usar Biango: para qué sirve cada uno, qué tiene que tener y dónde comprarlo. Comprar aquí no es obligatorio: vale cualquiera que cumpla lo que dice su tarjeta, también el que ya tengas.')}
      </p>
      {q.isLoading ? <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{t('pages.Tienda.un_momento', 'Un momento…')}</div>
        : producto ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-start' }}>
            <Link to={RUTA_TIENDA} data-volver-tienda="" style={{ fontSize: '13px', fontWeight: 700, color: 'var(--primary)' }}>{t('pages.Tienda.toda_la_tienda', '← Toda la Tienda')}</Link>
            {uno ? <TarjetaProducto producto={uno} ficha />
              : <div data-producto-no-esta="" style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{t('pages.Tienda.este_aparato_no_esta_en', 'Este aparato no está en la Tienda.')}</div>}
          </div>
        ) : productos.length ? (
          <div data-tarjetas-tienda="" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))', gap: '14px' }}>
            {productos.map((p) => <TarjetaProducto key={p.clave} producto={p} verFicha={verFicha} />)}
          </div>
        ) : <div data-tienda-vacia="" style={{ fontSize: '13px', color: 'var(--text-muted)' }}>{t('pages.Tienda.ahora_mismo_no_hay_nada', 'Ahora mismo no hay nada en la Tienda.')}</div>}
      {/* En la ficha, la frase legal solo si ESE aparato lleva enlaces con el identificador (lo de Biango no los lleva). */}
      {(producto ? !!uno : productos.length > 0) && (
        <PieTienda frases={producto ? (uno && uno.vendedor !== 'biango' && (uno.enlaces || []).some((e) => e && e.afiliado) ? frases : []) : frases} />
      )}
    </div>
  )
}

/** /donde-comprar/<aparato> (el enlace «Dónde comprarla» del 13-oct): a su ficha en la Tienda. */
export function RedirDondeComprar() {
  const { sitio } = useParams()
  return <Navigate to={rutaProducto(sitio)} replace />
}
